import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overflowText'
})
export class OverflowTextPipe implements PipeTransform {
  transform(nzLabel: string, showNum: number = 20): string {
    if (!nzLabel || nzLabel.length <= showNum) {
      return nzLabel;
    }
    return nzLabel.substr(0, showNum) + '...';
  }

}
